const { normalize } = require("../strings");
const R = require("ramda");

const sort = (offs) =>
	offs.sort((a, b) => {
		if (typeof a[2] === "undefined" || typeof b[2] === "undefined")
			return NaN;
		return a[2].distance - b[2].distance;
	});
const tap = (v) => {
	return v;
};

export const parseSearchResults = (search, results) => {
	if (search) {
		return R.pipe(
			R.filter(([office]) =>
				R.includes(normalize(search), normalize(office))
			),
			tap,
			sort,
			R.take(5),
			R.addIndex(R.map)(([name, category, slug]) => ({
				name,
				category,
				slug,
			}))
		)(results);
	}
};

export const getNestedResults = (search, visibleOffices) =>
	visibleOffices.filter((office) =>
		office.name.toLowerCase().includes(search.toLowerCase())
	);
